// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"d53e06e2","707":"be4332af","740":"9285cd6d"}[chunkId] + ".chunk.js";
};